import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from "vue-router";
import AppFooter from "@/views/partial/footer.vue";
import AppHeader from "@/views/partial/header.vue";
import faq from "@/views/partial/faq.vue";
import testimonials from "@/views/partial/testimonials.vue";
import BranchMap from "@/views/partial/map.vue";
import partners from "@/views/partial/partners.vue";
import "vue3-carousel/carousel.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
// Home data (siteSettings/countries/etc.) is loaded by home/index.vue itself
// via useHomeStore().getHome() - it is not needed at this App shell level.

// A repo-wide grep found exactly five naive-ui components used anywhere in
// this app, all five right here, all provider wrappers - naive-ui is
// globally registered in main.ts (app.use(naive)) for just these five.
// Named on-demand imports (`import { NConfigProvider, ... } from
// "naive-ui"`) were tried here as a bundle-size fix and *measured*, not
// assumed: it did not shrink the production bundle (chunk-vendors actually
// grew by ~38 KiB) because naive-ui's package is not tree-shaken by plain
// ESM named imports alone without an additional bundler-level plugin
// (e.g. unplugin-vue-components or a babel-plugin-import style resolver),
// which this project does not have configured. Reverted rather than kept
// as an unproven "optimization" - see
// docs/v4-migration/DERAYAH-VUE-V4-FULL-MODERNIZATION-CERT-001.md,
// Performance Findings, for the measured before/after numbers and the
// real fix this would need (adding such a plugin) if pursued later.

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_dialog_provider = _resolveComponent("n-dialog-provider")!
  const _component_n_notification_provider = _resolveComponent("n-notification-provider")!
  const _component_n_message_provider = _resolveComponent("n-message-provider")!
  const _component_n_loading_bar_provider = _resolveComponent("n-loading-bar-provider")!
  const _component_n_config_provider = _resolveComponent("n-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createVNode(_component_n_config_provider, null, {
      default: _withCtx(() => [
        _createVNode(_component_n_loading_bar_provider, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_message_provider, { placement: "bottom-left" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_notification_provider, {
                  placement: "top-right",
                  max: 5,
                  scrollable: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_dialog_provider, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_view)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(partners),
    (_unref(route).path !== '/contact')
      ? (_openBlock(), _createBlock(BranchMap, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(testimonials),
    _createVNode(faq),
    _createVNode(AppFooter)
  ], 64))
}
}

})